import { Component, createElement,createRef, h } from 'preact';

export default class PreferredBranchBarMobile extends Component {

	modalRef = createRef();

	constructor(props) {
		super();
		this.state = {
			selected_store: window.tccdata.stores[window.tccdata.selected_store_id]
		}
		this.handleStoreChange = this.handleStoreChange.bind(this);

		// this is bad and should probably use a global state handler instead but whatever
		// will listen for any branch modification event to update all branchselection internal states
		window.addEventListener('branchModified', (e) => {
			this.handleStoreChange()
		}, false);

	}

	render(props, state) {
		if(state.selected_store) {
			return this.renderSelectedStore(props, state);
		}
		return (
			<div class={'mobile-selectedStore'}>
			</div>
		)
	}

	renderSelectedStore(props, state) {
		return (
			<div class={'mobile-selectedStore'}>
				<span>
					Your selected store is { state.selected_store.branchName }
				</span>
			</div>

		)
	}



	handleStoreChange() {
		this.setState({
			selected_store: window.tccdata.stores[window.tccdata.selected_store_id]
		}, this.forceUpdate)
	}

}
